var exports = {
  "Wf": "x93eb46d8--6c22fd--small-pin",
  "YE": "x93eb46d8--6c22fd--large-pin",
  "Kk": "x93eb46d8--6c22fd--icon",
};

module.exports = exports;
